import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, AlteraEndereco } from './types';

export const INITIAL_STATE: AlteraEndereco = {
	status: 0,
	data: null,
};

export default function alteraEnderecoCartao(
	state = INITIAL_STATE,
	action: ReducerAction,
): AlteraEndereco {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ALTERA_ENDERECO: {
				break;
			}

			case Types.ALTERA_ENDERECO_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload.data;
				break;
			}

			case Types.ALTERA_ENDERECO_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.LIMPAR_ALTERA_ENDERECO: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
